import { render, staticRenderFns } from "./purchaseScanqrOrderList.vue?vue&type=template&id=b700e55e&scoped=true"
import script from "./purchaseScanqrOrderList.vue?vue&type=script&lang=js"
export * from "./purchaseScanqrOrderList.vue?vue&type=script&lang=js"
import style0 from "./purchaseScanqrOrderList.vue?vue&type=style&index=0&id=b700e55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b700e55e",
  null
  
)

export default component.exports